/**
 * External Dependencies
 */
import {
	registerScripts,
} from '@blockhandbook/block-fast-refresh';

/**
 * WordPress Dependencies
 */

/**
 * Internal Dependencies
 */

registerScripts( { context: () => require.context( './', true, /scripts\.js$/ ), module } );
